import { ThemeProvider } from '@mui/material/styles'
import { CssBaseline } from '@mui/material'
import { HelmetProvider } from 'react-helmet-async'
import MaintenanceScreen from './components/Maintenance'
import theme from './theme/theme'
import './App.css'

function App() {
  return (
    <HelmetProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <MaintenanceScreen />
      </ThemeProvider>
    </HelmetProvider>
  )
}

export default App
